import * as React from "react";
import {
    ButtonDropdown, DropdownToggle, DropdownMenu, Button, DropdownItem
} from 'reactstrap';

class ButtonDropDownProps {
    public botones: JSX.Element[];
}

export function DropDownButton(props: ButtonDropDownProps): JSX.Element {

    const [dropdownOpen, setDropdownOpen] = React.useState(false);

    var botones = props.botones;

    if (botones == null || botones.length == 0) {
        return null;
    }

    if (botones.length == 1) {
        return botones[0];
    }
    else if (botones.length > 1) {
        return <ButtonDropdown
            isOpen={dropdownOpen}
            toggle={() => {
                setDropdownOpen(!dropdownOpen);
            }}>
            <DropdownToggle className="btn-rounded btn btn-secondary" caret color="primary">
                Acciones
            </DropdownToggle>
            <DropdownMenu className="botones_acciones">
                {botones.map((button, index) => {

                    if (button.props.divider) {
                        return React.cloneElement(button, { key: index });
                    }
                    else {
                        return <DropdownItem
                            key={index}
                            onClick={button.props.onClick}
                            disabled={button.props.disabled}

                        >
                            {button.props.children}
                        </DropdownItem>
                    }

                })}
            </DropdownMenu>
        </ ButtonDropdown>
    }
}
